import styled from 'styled-components';

export const InfoText = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const HelpText = styled(InfoText)`
  margin-top: 24px;
  margin-bottom: 12px;
`;
